module.exports = __webpack_public_path__ + "img/pathgroup_1.0164e1eb.svg";